import React, { useState } from 'react';

const Projects = () => {
  const [currentProject, setCurrentProject] = useState(0);
  
  const projects = [
    {
      id: 1,
      title: 'Интеграция AI в бизнес',
      description: 'Разработка и внедрение систем искусственного интеллекта для автоматизации бизнес-процессов. Обучение LLM/VLM под специфические задачи клиента.',
      image: '/api/placeholder/700/400',
      tags: ['LLM', 'Machine Learning', 'Бизнес-аналитика'],
    },
    {
      id: 2,
      title: 'Умный загородный дом',
      description: 'Разработка кастомной системы умного дома с ИИ-ассистентом, контролем безопасности, оптимизацией энергопотребления и интеграцией с IoT-устройствами.',
      image: '/api/placeholder/700/400',
      tags: ['Smart Home', 'IoT', 'AI Assistant'],
    },
    {
      id: 3,
      title: 'Робо-пёс SPOT-Т100',
      description: 'Разработка автономного робота-собаки с ИИ для выполнения различных задач: мониторинг территорий, помощь в чрезвычайных ситуациях, перенос грузов.',
      image: '/api/placeholder/700/400',
      tags: ['Робототехника', 'Computer Vision', 'Автономные системы'],
    },
  ];

  const nextProject = () => {
    setCurrentProject((prev) => (prev === projects.length - 1 ? 0 : prev + 1));
  };

  const prevProject = () => {
    setCurrentProject((prev) => (prev === 0 ? projects.length - 1 : prev - 1));
  };

  return (
    <div className="py-16 md:py-24">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">Наши проекты</h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Посмотрите на примеры наших реализованных проектов внедрения ИИ и современных технологий в различных отраслях
          </p>
        </div>
        
        <div className="relative max-w-4xl mx-auto">
          {/* Project Showcase */}
          <div className="bg-white rounded-lg shadow-xl overflow-hidden">
            <div className="md:flex">
              <div className="md:w-1/2">
                <img 
                  src={projects[currentProject].image} 
                  alt={projects[currentProject].title} 
                  className="w-full h-64 md:h-full object-cover"
                />
              </div>
              <div className="md:w-1/2 p-6 md:p-8">
                <h3 className="text-2xl font-bold text-gray-800 mb-3">{projects[currentProject].title}</h3>
                <p className="text-gray-600 mb-6">{projects[currentProject].description}</p>
                <div className="flex flex-wrap gap-2 mb-6">
                  {projects[currentProject].tags.map((tag, index) => (
                    <span 
                      key={index} 
                      className="px-3 py-1 bg-blue-100 text-blue-600 text-sm font-medium rounded-full"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
                <button className="px-4 py-2 bg-blue-600 text-white rounded-md text-sm font-medium hover:bg-blue-700 transition-colors">
                  Подробнее о проекте
                </button>
              </div>
            </div>
          </div>
          
          {/* Navigation Arrows */}
          <button 
            onClick={prevProject}
            className="absolute top-1/2 left-0 -translate-y-1/2 -translate-x-1/2 md:-translate-x-6 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center text-blue-600 hover:bg-blue-50 transition-colors"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>
          <button 
            onClick={nextProject}
            className="absolute top-1/2 right-0 -translate-y-1/2 translate-x-1/2 md:translate-x-6 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center text-blue-600 hover:bg-blue-50 transition-colors"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>
        
        {/* Project Indicators */}
        <div className="flex justify-center mt-8 space-x-2">
          {projects.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentProject(index)}
              className={`w-3 h-3 rounded-full transition-colors ${
                currentProject === index ? 'bg-blue-600' : 'bg-gray-300'
              }`}
            />
          ))}
        </div>
        
        <div className="mt-16 text-center">
          <button className="px-6 py-3 bg-white border border-gray-300 text-gray-700 rounded-lg font-medium hover:bg-gray-50 transition-colors">
            Смотреть все проекты
          </button>
        </div>
      </div>
    </div>
  );
};

export default Projects;